const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isUuid(value: string): boolean {
  return UUID_RE.test(value);
}

/** Parse comma-separated UUIDs; drops invalid tokens and dedupes preserving order. */
export function parseUuidListParam(raw: string | null): string[] {
  if (!raw?.trim()) return [];
  const seen = new Set<string>();
  const result: string[] = [];
  for (const part of raw.split(",")) {
    const id = part.trim();
    if (!id || !isUuid(id) || seen.has(id)) continue;
    seen.add(id);
    result.push(id);
  }
  return result;
}

export function serializeUuidListParam(ids: string[]): string {
  return ids.filter((id) => isUuid(id)).join(",");
}
